// =============================================================================
// NAD+ Comparison Table Section Component
// =============================================================================

export class NADComparisonTable {
  private element: HTMLElement;
  private observer: IntersectionObserver | null = null;

  constructor(element: HTMLElement) {
    this.element = element;
    this.init();
  }

  private init(): void {
    this.setupScrollAnimation();
  }

  /**
   * Fade in each row as it becomes visible; stagger delays come from the
   * nth-child rules in the section SCSS
   */
  private setupScrollAnimation(): void {
    const rows = this.element.querySelectorAll<HTMLElement>('.nad-comparison-table__row');

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            this.observer?.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -30px 0px'
      }
    );

    rows.forEach((row) => this.observer?.observe(row));
  }

  public destroy(): void {
    this.observer?.disconnect();
    this.observer = null;
    this.element.querySelectorAll('.nad-comparison-table__row.animate-in')
      .forEach(el => el.classList.remove('animate-in'));
  }

  static initializeAll(): void {
    document.querySelectorAll<HTMLElement>('.nad-comparison-table')
      .forEach(el => {
        if (!(el as any)._nadComponentInstance) {
          (el as any)._nadComponentInstance = new NADComparisonTable(el);
        }
      });
  }
}
